import BaseApiRequest from "./BaseApiRequest";
import { URL_PLAID_LIST } from "../ApiUrls";
import { METHOD } from "../Constants";

export default class PlaidListVerificationsRequest extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  constructor(clientUserId) {
    super();
    this.clientUserId = clientUserId;
  }

  getMethod = () => this.method;

  getUrl = () => URL_PLAID_LIST.replace("%1", this.clientUserId);

  getBody = () => ({});
}
